// extracted by mini-css-extract-plugin
export default {"sidebar__wrapper":"Sidebar_sidebar__wrapper__Cmbc5"};